function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgba(0, 0, 0, 0.0)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'sour-dragon-fruit-strawberry-punch': 'rgb(201, 76, 102)','chocolate-milk': 'rgb(166, 123, 91)','vanilla-ice-cream': 'rgb(243, 229, 171)','pumpkin-pie-seasonal-flavor': 'rgb(230, 126, 34)','aqua-blue': 'rgb(0, 193, 255)','light-grey': 'rgb(211, 211, 211)','sage': 'rgb(156, 175, 136)','black': 'rgb(0, 0, 0)','military-olive': 'rgb(75, 83, 32)','tobacco-brown': 'rgb(113, 84, 62)','rock-ridge': 'rgb(145, 140, 134)','iron-blue': 'rgb(90, 125, 154)','lunar-rock': 'rgb(197, 197, 190)','coyote-brown': 'rgb(129, 97, 60)','od-green': 'rgb(74, 93, 35)','white': 'rgb(255, 255, 255)','nomad': 'rgb(192, 172, 122)','overland-trek': 'rgb(96, 90, 82)','earth-brown': 'rgb(93, 71, 58)','glacier': 'rgb(197, 198, 199)','oakmoss': 'rgb(126, 123, 82)','latte': 'rgb(166, 123, 91)','ivy': 'rgb(85, 107, 79)','bone': 'rgb(227, 218, 201)','black': 'rgb(0, 0, 0)',};

    this.images = {'rainbow-sherbet': 'url("//thealphacountry.com/cdn/shop/files/rainbow3_68x.jpg?v=11264886723776047843")','mango-pineapple': 'url("//thealphacountry.com/cdn/shop/files/mangopineapple_68x.jpg?v=16869827543711735335")','watermelon-guava-lime': 'url("//thealphacountry.com/cdn/shop/files/watermelonguavalime_68x.avif?v=17646430241963968034")','americas-popsicle': 'url("//thealphacountry.com/cdn/shop/files/americaspopsicle_68x.jpg?v=17572569310392880966")','strawberry-kiwi': 'url("//thealphacountry.com/cdn/shop/files/watermelonguavalime_68x.avif?v=17646430241963968034")','pineapple-orange-kiwi': 'url("//thealphacountry.com/cdn/shop/files/pineappleorangekiwi_68x.avif?v=16497771983102333677")','mango-lime-pineapple': 'url("//thealphacountry.com/cdn/shop/files/mangolimepineapple2_68x.jpg?v=17910671235487421021")','strawberry-lemonade': 'url("//thealphacountry.com/cdn/shop/files/strawberrylemonade_68x.jpg?v=3659378137467592632")','mixed-berry': 'url("//thealphacountry.com/cdn/shop/files/mixedberry_68x.jpg?v=16220866645788263496")','kiwi-lime': 'url("//thealphacountry.com/cdn/shop/files/kiwilime_68x.jpg?v=16934575554179828711")','frogskin': 'url("//thealphacountry.com/cdn/shop/files/frogskin_68x.jpg?v=14594764517548109244")','aor1': 'url("//thealphacountry.com/cdn/shop/files/AOR1_68x.jpg?v=738730481687288314")','miami-vibez': 'url("//thealphacountry.com/cdn/shop/files/miamivibez_68x.jpg?v=2066236496120472390")','deep-forest': 'url("//thealphacountry.com/cdn/shop/files/deepforest_68x.jpg?v=17606392160989448186")','desert-tiger': 'url("//thealphacountry.com/cdn/shop/files/deserttiger_68x.jpg?v=18026825252770153365")','black-tiger-stripe': 'url("//thealphacountry.com/cdn/shop/files/blacktigerstripe_68x.jpg?v=8703028108453027129")','night-raid-camo': 'url("//thealphacountry.com/cdn/shop/files/nightraidcamo_68x.jpg?v=16888308682321401106")','phantom-camo': 'url("//thealphacountry.com/cdn/shop/files/phantom_68x.png?v=2270418212006925430")','white-black': 'url("//thealphacountry.com/cdn/shop/files/white_black2_68x.jpg?v=12598173899930970358")',};

    this.triggers = ['flavor','color',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
